
import React from 'react';
import ValuedPeopleCarousel from '@/components/ui/ValuedPeopleCarousel';
import { getRegularValuedPeople, featuredAchievers, regularAchievers } from '@/data/articles';
import { Trophy, Star, Users, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import ValuedPeopleCard from '@/components/ui/ValuedPeopleCard';
import { getSuccessStoriesByAchiever } from '@/data/successStories';
import { Badge } from '@/components/ui/badge';

const ValuedPeopleSection: React.FC = () => {
  const regularValuedPeople = getRegularValuedPeople();
  const navigate = useNavigate();

  return (
    <>
      {featuredAchievers.length > 0 && (
        <section className="py-16 px-4 md:px-6 bg-gradient-to-r from-purple-50 via-purple-100/30 to-purple-50 border-y border-purple-200/50 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full opacity-5 bg-grid-pattern"></div>
          <div className="absolute -top-24 -left-24 w-64 h-64 rounded-full bg-gradient-to-br from-purple-200 to-purple-300 blur-3xl opacity-30"></div>
          <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-gradient-to-tr from-amber-200 to-amber-300 blur-3xl opacity-20"></div>
          <div className="absolute top-1/4 right-1/4 w-32 h-32 rounded-full bg-gradient-to-tr from-amber-300 to-amber-400 blur-3xl opacity-10 animate-pulse"></div>
          
          <div className="container mx-auto relative z-10">
            <div className="mb-8 text-center">
              <div className="flex items-center justify-center mb-3">
                <Trophy className="w-8 h-8 text-amber-500 mr-3 animate-bounce" />
                <h2 className="text-3xl md:text-4xl font-bold mx-2 font-serif bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-purple-900">
                  Featured Achievers
                </h2>
                <Trophy className="w-8 h-8 text-amber-500 ml-3 animate-bounce" />
              </div>
              <p className="text-muted-foreground max-w-2xl mx-auto text-base">
                Celebrating individuals who have demonstrated exceptional performance and impact in their fields
              </p>
            </div>
            
            <ValuedPeopleCarousel 
              articles={featuredAchievers} 
              className="premium-carousel"
              enhancedImages={true}
              autoplay={true}
              autoplaySpeed={5000}
              showControls={true}
            />
          </div>
        </section>
      )}
    </>
  );
};

export default ValuedPeopleSection;
